import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { LoginService } from './login.service';
import { StorageService } from './storage.service';
import { AppUser } from '../models/app.user';

let OneSignal: any;

@Injectable()
export class OneSignalService {

  ONE_SIGNAL_APP_ID: string = environment.oneSignalAppID;
  Safari_Web_ID: string = environment.oneSignalSafariWebID;
  ONE_SIGNAL_subdomain_name: string = environment.subdomainName;

  oneSignalInit: boolean;
  oneSignalId: string;
  user_id: number;

  tryingUntilGetIt: NodeJS.Timer;

  constructor(
    private storageService: StorageService,
    private cookieService: CookieService,
    private loginService: LoginService,
  ) {
    this.oneSignalInit = this.storageService.restore(this.normalizeString(environment.appname) + '_onesignal') == 'initialized';
    this.oneSignalId = this.cookieService.get(this.normalizeString(environment.appname) + '_onesignalId');
  }

  public init(): void {
    this.oneSignalInit = this.storageService.restore(this.normalizeString(environment.appname) + '_onesignal') == 'initialized';
    this.oneSignalInit ? console.log("I'm listening") : this.loadOneSignal();
  }

  private loadOneSignal(): void {
    this.tryingUntilGetIt = setInterval((): void => {
      OneSignal = window['OneSignal'] || [];
      if (OneSignal !== undefined) {
        clearInterval(this.tryingUntilGetIt as unknown as number);
        this.initOneSignal();
      }
    }, 500);
    setTimeout((): void => {
      clearInterval(this.tryingUntilGetIt as unknown as number);
    }, 3000);
  }

  private initOneSignal(): void {
    OneSignal = window['OneSignal'] || [];
    this.setUserID();
    let OneSignalObj: any = {
      appId: this.ONE_SIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: false,
      },
      promptOptions: {
        actionMessage: environment.appname + ' deseja lhe enviar notificações!',
        acceptButtonText: 'Aceitar',
        cancelButtonText: 'Recusar',
        showCredit: false
      }
    }
    if (this.Safari_Web_ID != '') {
      OneSignalObj['safari_web_id'] = this.Safari_Web_ID;
    }
    if (this.ONE_SIGNAL_subdomain_name != '') {
      OneSignalObj['subdomainName'] = this.ONE_SIGNAL_subdomain_name;
    }
    OneSignal.push(['init', {
      appId: this.ONE_SIGNAL_APP_ID,
      safari_web_id: this.Safari_Web_ID,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: false,
      },
      promptOptions: {
        actionMessage: environment.appname + ' deseja lhe enviar notificações!',
        acceptButtonText: 'Aceitar',
        cancelButtonText: 'Recusar',
        showCredit: false
      },
      subdomainName: this.ONE_SIGNAL_subdomain_name,
    }]);
    this.storageService.store(this.normalizeString(environment.appname) + '_onesignal', 'initialized');
    this.checkIfSubscribed();
  }

  public setUserID(): void {
    this.loginService.loggedUser$.subscribe((user: AppUser): void => {
      if (this.exists(user)) {
        this.user_id = user.id;
        if (Number.isNaN(this.user_id) || this.user_id == null || this.user_id == undefined || Number.isNaN(this.user_id)) {
          OneSignal.deleteTag("user_id",
            (): void => { }
          );
          OneSignal.removeExternalUserId(this.user_id);
        } else {
          OneSignal.sendTag('user_id', this.user_id,
            (): void => { }
          );
          OneSignal.sendTag('type', 'assinante',
            (): void => { }
          );
          OneSignal.setExternalUserId(this.user_id);
        }
      }
    });
  }

  public checkIfSubscribed(): void {
    OneSignal = window['OneSignal'] || [];
    OneSignal.push(
      (): void => {
        OneSignal.isPushNotificationsEnabled(
          (isEnabled: boolean): void => {
            if (isEnabled) {
              this.getUserID();
              this.setUserID();
            } else {
              this.subscribe();
            }
          },
          (): void => { }
        );
      }
    );
  }

  private getUserID(): void {
    OneSignal.getUserId().then(
      (userId: string | number): void => {
        this.oneSignalId = typeof(userId) == 'number' ? userId.toString() : userId;
      }
    );
  }

  private subscribe(): void {
    OneSignal.push((): void => {
        OneSignal.push(['registerForPushNotifications']);
        OneSignal.on('subscriptionChange',
          (): void => {
            this.listenForNotification();
            OneSignal.getUserId().then(
              (userId: string | number): void => {
                this.oneSignalId = typeof(userId) == 'number' ? userId.toString() : userId;
                this.updateLocalUserProfile();
                this.setUserID();
              }
            );
          }
        );
      }
    );
  }

  private listenForNotification(): void {
    OneSignal.on('notificationDisplay',
      (): void => {
        this.listenForNotification();
      }
    );
  }

  private updateLocalUserProfile(): void {
    this.cookieService.set(this.normalizeString(environment.appname) + '_onesignalId', this.oneSignalId);
  }

  private normalizeString(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\ /g, '_');
  }

  private exists(element: any): boolean {
    return element !== null && element !== undefined && element != '';
  }
}
